<template>
  <div class="zhaopinhui">
    <Card>
      <Form ref="queryForm" :model="queryParams" inline :label-width="80">
        <FormItem label="省份" prop="provinceId">
          <Select v-model="queryParams.provinceId" clearable style="width: 200px" @on-change="changeProvince">
            <Option v-for="item in provinces" :value="item.value" :key="item.id">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="城市" prop="cityId">
          <Select v-model="queryParams.cityId" clearable style="width: 200px" :disabled="!queryParams.provinceId">
            <Option v-for="item in cities" :value="item.value" :key="item.id">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="专场名称" prop="jobfairName">
          <Input v-model="queryParams.jobfairName" clearable placeholder="" style="width: 200px"></Input>
        </FormItem>
        <FormItem label="专场类型" prop="specialType">
          <Select v-model="queryParams.specialType" clearable style="width: 200px">
            <Option v-for="item in specialTypeList" :value="item.value" :key="item.id">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="专场形式" prop="jobType">
          <Select v-model="queryParams.jobType" clearable style="width: 200px">
            <Option v-for="item in jobTypeList" :value="item" :key="item">{{ item }}</Option>
          </Select>
        </FormItem>
        <FormItem label="专场时间" prop="date">
          <DatePicker
            type="datetimerange"
            format="yyyy-MM-dd HH:mm"
            placeholder="开始时间-结束时间"
            style="width: 300px"
            v-model="queryParams.date"
            @on-change="changeTime"
          />
        </FormItem>
        <FormItem label="状态" prop="applyStatus">
          <Select v-model="queryParams.applyStatus" clearable style="width: 200px">
            <Option v-for="(item, index) in companyStatusList" :value="item.value" :key="index">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem style="float: right; margin-right: 0">
          <Button type="primary" @click="query" style="margin-right: 10px">查询</Button>
          <Button @click="resetQueryForm">重置</Button>
        </FormItem>
      </Form>
      <ButtonGroup style="margin-bottom: 20px">
        <Button
          v-for="(item, index) in statusList"
          :key="index"
          :type="index === queryParams.activeStatus ? 'primary' : 'default'"
          @click="changeStatus(index)"
        >
          {{ item }}
        </Button>
      </ButtonGroup>
      <Table :columns="column" :data="list">
        <template slot-scope="{ row }" slot="city">
          <span style="display: inline-block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
            {{ row.province ? row.province.label : '' }} {{ row.city ? row.city.label : '' }}
          </span>
        </template>
        <template slot-scope="{ row }" slot="time">
          <span>{{ row.startTime | formatTime }} - {{ row.endTime | formatTime }}</span>
        </template>
        <template slot-scope="{ row }" slot="applyTime">
          <span>{{ row.registStartTime | formatTime }} - {{ row.registEndTime | formatTime }}</span>
        </template>
        <template slot-scope="{ row }" slot="companyCount">
<!--          <span>{{ row.approvedCount }} / {{ row.applyCount || '不限' }}</span>-->
          <span>{{ row.approvedCount }}</span>
        </template>
        <template slot-scope="{ row }" slot="status">
          <div v-if="row.jobfairCompany">
            <Tag v-if="row.jobfairCompany.status === 0" color="blue">审核中</Tag>
            <Tag v-else-if="row.jobfairCompany.status === 1" color="green">已通过</Tag>
            <Tag v-else-if="row.jobfairCompany.status === 2" color="red">未通过</Tag>
          </div>
          <Tag color="orange" v-else>未报名</Tag>
        </template>
        <template slot-scope="{ row }" slot="action">
          <a v-if="!row.jobfairCompany && unable(row.registStartTime, row.registEndTime)" style="color: #aaaaaa">报名</a>
          <a v-else-if="!row.jobfairCompany" @click="showForm(row)" style="color: #67c23a">报名</a>
          <!-- 状态为已通过、未通过时，隐藏取消报名按钮 -->
          <a v-else-if="row.jobfairCompany.status !== 1 && row.jobfairCompany.status !== 2" @click="cancel(row.jobfairCompany)">取消报名</a>
          <a v-else-if="row.jobfairCompany.status === 1 || row.jobfairCompany.status === 2" style="color: #aaaaaa">取消报名</a>
          <a @click="showDetail(row)" style="margin-left: 10px">显示详情</a>
        </template>
      </Table>
      <Page
        v-if="pagination.total"
        style="padding: 10px; background: #fff"
        class="page"
        @on-change="changePage"
        :current="pagination.pageIndex"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        size="small"
        show-elevator
      />
    </Card>

    <Modal :loading="loading" v-model="applyShow" title="报名" @on-ok="apply">
      <Form ref="form" :model="applyForm" :rules="applyRule" label-position="top" v-if="row">
        <!-- <FormItem label="选择活动场次" prop="sessionIds">
          <CheckboxGroup v-model="applyForm.sessionIds">
            <Checkbox :label="session.id" v-for="session in row.sessions" :key="session.id">
              {{ session.title }} （{{ session.startTime | formatTime }} - {{ session.endTime | formatTime }}）
            </Checkbox>
          </CheckboxGroup>
        </FormItem> -->
        <FormItem label="选择招聘岗位" prop="jobIds">
          <Transfer
            filterable
            :titles="['可选岗位', '已选岗位']"
            :data="allJobs"
            :target-keys="applyForm.jobIds"
            @on-change="handleChange"
          ></Transfer>
        </FormItem>
      </Form>
    </Modal>
    <Drawer v-model="detailShow" title="招聘会详情" :width="800">
      <Tabs type="card" v-if="row">
        <TabPane label="基本信息">
          <Row class="custom-descriptions" type="flex">
            <Col span="4">
              <p class="description-label">主图：</p>
            </Col>
            <Col span="8">
              <p class="description-value"><img class="banner" :src="row.cover" /></p>
            </Col>
            <Col span="4">
              <p class="description-label">专场名称：</p>
            </Col>
            <Col span="8">
              <p class="description-value">{{ row.jobfairName }}</p>
            </Col>
          </Row>
          <Row class="custom-descriptions">
            <Col span="4">
              <p class="description-label">专场类型：</p>
            </Col>
            <Col span="8">
              <p class="description-value">{{ row.specialType }}</p>
            </Col>
            <Col span="4">
              <p class="description-label">专场形式：</p>
            </Col>
            <Col span="8">
              <p class="description-value">{{ row.jobType }}</p>
            </Col>
          </Row>
          <Row class="custom-descriptions">
            <Col span="4">
              <p class="description-label">省份·城市：</p>
            </Col>
            <Col span="8">
              <p class="description-value">{{ row.province.label }} {{ row.city.label }}</p>
            </Col>
            <Col span="4">
              <p class="description-label">地址：</p>
            </Col>
            <Col span="8">
              <p class="description-value">{{ row.address }}</p>
            </Col>
          </Row>
          <Row class="custom-descriptions">
            <Col span="4">
              <p class="description-label">报名时间：</p>
            </Col>
            <Col span="8">
              <p class="description-value">{{ row.registStartTime | formatTime }} - {{ row.registEndTime | formatTime }}</p>
            </Col>
            <Col span="4">
              <p class="description-label">活动时间：</p>
            </Col>
            <Col span="8">
              <p class="description-value">{{ row.startTime | formatTime }} - {{ row.endTime | formatTime }}</p>
            </Col>
          </Row>
          <Row class="custom-descriptions">
            <Col span="4">
              <p class="description-label">举办单位：</p>
            </Col>
            <Col span="8">
              <p class="description-value">{{ row.organizers }}</p>
            </Col>
            <Col span="4">
              <p class="description-label">参与企业数上限：</p>
            </Col>
            <Col span="8">
              <p class="description-value">{{ row.enrollmentLimit ? row.enrollmentLimit : '无限制' }}</p>
            </Col>
          </Row>
          <!-- <Row class="custom-descriptions" type="flex">
            <Col span="4">
              <p class="description-label">活动场次：</p>
            </Col>
            <Col span="20">
              <p class="description-value" v-for="session in row.sessions" :key="session.id">
                {{ session.title }} （{{ session.startTime | formatTime }} - {{ session.endTime | formatTime }}）
              </p>
            </Col>
          </Row> -->
          <div v-if="!row.jobfairCompany && !unable(row.registStartTime, row.registEndTime)" @click="showForm(row)" class="baoming">
            <Button type="primary">报名</Button>
          </div>
        </TabPane>
        <TabPane label="已报名企业">
          <Table :columns="companyColumn" :data="companyData">
            <template slot-scope="{ row }" slot="time">
              <span>{{ row.createdAt | formatTime }}</span>
            </template>
          </Table>
        </TabPane>
      </Tabs>
    </Drawer>
  </div>
</template>

<script>
import Resume from '_c/resume/resume';
import Filtrate from '_c/filtrate/filtrate';
import typeWrap from '_c/typeWrap/typeWrap';
import dayjs from 'dayjs';
import {Toast, TOAST_TYPE} from "@/TUIKit/components/common/Toast/index";

export default {
  data() {
    return {
      status: '0',
      list: [{ name: '上班族' }],
      resume_list: {},
      saixuan: false,
      flag: false,
      form: {},
      saixuanList: {},
      pagination: {},
      applyShow: false,
      applyForm: {},
      row: null,
      allJobs: [],
      loading: true,
      detailShow: false,
      provinces: [],
      cities: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        idOrder: 'desc',
        activeStatus: 0,
        enableApply: 1
      },
      applyRule: {
        // contactName: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
        // contactPhone: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
        jobIds: [{ required: true, message: '岗位不能为空', trigger: 'blur', min: 1, type: 'array' }]
        // sessionIds: [{ required: true, message: '场次不能为空', trigger: 'blur', min: 1, type: 'array' }]
      },
      companyColumn: [
        { title: '企业名称', key: 'companyName' },
        { title: '报名时间', slot: 'time', width: 200 }
      ],
      companyData: [],
      column: [
        { title: '序号', type: 'index', align: 'center', width: 120 },
        { title: '省份·城市', slot: 'city', width: 120 },
        { title: '专场名称', key: 'jobfairName', width: 300 },
        { title: '专场类型', key: 'specialType', width: 100 },
        { title: '专场形式', key: 'jobType', width: 100 },
        { title: '专场时间', slot: 'time', width: 240 },
        { title: '专场地址', key: 'address', width: 240 },
        { title: '报名企业数', slot: 'companyCount', width: 120 },
        { title: '状态', slot: 'status', width: 120 },
        { title: '报名时间', slot: 'applyTime', width: 240 },
        { title: '操作', slot: 'action', width: 200, fixed: 'right' }
      ],
      statusList: ['全部', '未开始', '进行中', '已结束'],
      jobTypeList: ['就业直播', '线下活动'],
      companyStatusList: [
        { value: -1, label: '未报名' },
        { value: 0, label: '审核中' },
        { value: 1, label: '已通过' },
        { value: 2, label: '未通过' }
      ],
      specialTypeList: []
    };
  },
  components: {
    Resume,
    Filtrate,
    typeWrap
  },
  watch: {
    queryParams: {
      deep: true,
      handler(newVal) {
        console.log(newVal, this.column[6]);
        this.column[6].title = newVal.jobType === '在线直播' ? '直播地址' : '专场地址';
      }
    }
  },
  computed: {
    unable(start, end) {
      return (start, end) => {
        return dayjs().isAfter(dayjs(end)) || dayjs().isBefore(dayjs(start));
      };
    }
  },
  mounted() {
    this.getList();
    this.getJobs();
    this.getProvinces();
    this.getSpecialTypeList();
    // this.getResume_list();
  },
  methods: {
    query() {
      this.getList();
    },
    resetQueryForm() {
      this.$refs.queryForm.resetFields();
      this.queryParams.startTime = '';
      this.queryParams.endTime = '';
      this.getList();
    },
    changeProvince(e) {
      this.queryParams.city = undefined;
      this.$axios
        .request({
          url: 'front/v1/area/district/' + e,
          method: 'get'
        })
        .then(res => {
          this.cities = res.data;
          this.queryParams.cityId = this.cities[0].value;
        });
    },
    getProvinces() {
      this.$axios
        .request({
          url: 'front/v1/area/province',

          method: 'get'
        })
        .then(res => {
          this.provinces = res.data;
        });
    },
    showDetail(row) {
      this.detailShow = true;
      this.row = row;
      this.getChecksumCompanies(row.id);
      this.getCompanies(row.id);
    },
    getChecksumCompanies(id) {
      this.$axios
        .request({
          url: 'front/v1/company/jobfair-company/' +id,
          params: {
            status: 1
          },
          method: 'get'
        })
        .then(res => {

        }).catch(err => {
        Toast({
          message: err,
          type: TOAST_TYPE.ERROR,
        });
      });
    },
    getCompanies(id) {
      this.$axios
        .request({
          url: 'front/v1/company/jobfair-company',
          params: {
            jobfairId: id,
            pageSize: 500,
            status: 1
          },
          method: 'get'
        })
        .then(res => {
          this.companyData = res.data.list;
        });
    },
    cancel(jobfairCompany) {
      this.$Modal.confirm({
        title: '提示',
        content: '确定要取消报名',
        onOk: () => {
          this._doCancel(jobfairCompany.id);
        }
      });
    },
    _doCancel(id) {
      this.$axios
        .request({
          url: 'front/v1/company/jobfair/cancel',
          data: { id: id },
          method: 'post'
        })
        .then(res => {
          this.$Message['success']({
            background: true,
            content: '取消成功'
          });
          this.getList();
        });
    },
    apply() {
      this.$refs.form.validate(ok => {
        if (ok) {
          this._doApply();
        } else {
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 100);
        }
      });
    },
    _doApply() {
      this.$axios
        .request({
          url: 'front/v1/company/jobfair/apply',
          data: this.applyForm,
          method: 'post'
        })
        .then(res => {
          this.applyShow = false;
          this.getList(this.queryParams.pageIndex);
        })
        .catch(() => {
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 100);
        });
    },
    handleChange(ids) {
      this.$set(this.applyForm, 'jobIds', ids);
    },
    showForm(row) {
      this.applyForm = {
        id: row.id,
        sessionIds: [],
        jobIds: []
      };
      this.row = row;
      this.applyShow = true;
    },
    switchType(value) {
      this.status = value;
      this.getList();
    },
    getJobs() {
      this.$axios
        .request({
          url: 'front/v1/job/all'
        })
        .then(res => {
          this.allJobs = res.data;
        });
    },
    getList(page = 1) {
      this.queryParams.pageIndex = page;
      let data = { ...this.queryParams };
      delete data.date;
      this.$axios
        .request({
          url: 'front/v1/company/jobfair',
          params: data
        })
        .then(res => {
          this.list = res.data.list;
          if (this.list[0]) this.list[0].enrollmentCount = 5;
          this.pagination = { total: res.data.count, pageIndex: res.data.pageIndex, pageSize: res.data.pageSize };
        });
    },
    changePage(page) {
      this.getList(page);
    },
    startChat() {
      this.$axios
        .request({
          url: 'api/qiuzhi/message/send',
          method: 'post',
          data: { to: this.form.user_id, job_id: 0 }
        })
        .then(res => {
          if (res.data.to_user_id) {
            // this.$store.dispatch(
            //   "checkoutConversation",
            //   TIM.TYPES.CONV_C2C + res.data.to_user_id
            // );
          }
        });
    },
    changeStatus(index) {
      this.queryParams.activeStatus = index;
      this.queryParams.pageIndex = 1;
      this.getList();
    },
    changeTime(e) {
      this.queryParams.startTime = e[0];
      this.queryParams.endTime = e[1];
    },
    getSpecialTypeList() {
      this.$axios
        .request({
          method: 'get',
          url: 'api/v1/dict-data/front/option-select?dictType=specialType'
        })
        .then(res => {
          this.specialTypeList = res.data;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.banner {
  width: 200px;
  height: auto;
}
.custom-descriptions {
}

.description-label {
  font-weight: bold;
  height: 100%;
  background: #f0f0f0;
  padding: 8px;
  height: 100%;
}

.description-value {
  color: #999;
  padding: 8px;
}
.baoming {
  margin-top: 20px;
  text-align: center;
}
</style>
